<script setup>
import { ref } from "vue";
import { FormModal } from "@Components/Modal";
import { useForm } from "@/form";
import { FormInput, FormLabel } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";
import { ArrowRightIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["submit"]);

const { t: __ } = useI18n();

const modal = ref();

const form = useForm({
    url: "",
});

const show = () => {
    modal.value?.show();
};

const hide = () => {
    modal.value?.hide();
};

const search = async () => {
    if (form.url.length === 0) {
        return;
    }

    const response = await form.post("single_mode_url_source_search");

    emit("submit", response);
    hide();
};

defineExpose({ show, hide });
</script>

<template>
    <FormModal ref="modal" :title="__('Url')">
        <template #body>
            <form @submit.prevent="search">
                <FormLabel for="url-source-url">{{ __("URL") }}</FormLabel>
                <div class="flex justify-center gap-3 mt-2">
                    <div class="flex-1">
                        <FormInput id="url-source-url" v-model="form.url" :errors="form.getErrors('url')" :placeholder="`https://example.com`" :z="1" />
                    </div>
                    <div class="mt-[2px] flex-none">
                        <PrimaryButton type="submit" :processing="form.processing" :icon="ArrowRightIcon" :z="1" />
                    </div>
                </div>
            </form>
        </template>
    </FormModal>
</template>
